import {  Col, Typography } from "antd";
import { programPaymentScheduleStudentAcademy } from "../../../../shared/services";
import { TableColumns } from "../../../../shared/components/ui/Table/types";
import Table from "../../../../shared/components/ui/Table";
import { useNavigate, useParams } from "react-router-dom";

import moment from "moment";
import { CopyProgramSchedulePaymentStudentType } from "../../../../types/dto/scheduleStudent";
import { formatNumberPrice } from "../../../../shared/utils/Helper";
import { PaymentStatusBadge } from "../../../../shared/components/ui/AcademyStatusBadge";

const {Text, Title} = Typography;

export const TableAcademyStudentPendingPayment = () => {
  
  const columns: TableColumns<CopyProgramSchedulePaymentStudentType> = [
   
    {
      title: "Estudiante",
      dataIndex: "id",
      key: "name",
      width: 5,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Title style={{ fontSize: "0.74rem", fontWeight: "500" }} level={5}>
              {`${item?.program_student?.user?.first_name} ${item?.program_student?.user?.last_name}`}
            </Title>
          </Col>
        );
      },
    },
    {
      title: "Programa",
      key: "id",
      width: 4,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <Text className="capitalize">
              {item?.program_student?.program.name}
            </Text>
          </Col>
        );
      },
    },
    {
      title: "Fecha de Pago Programada",
      dataIndex: "month",
      key: "month",
      width: 6,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <span className="capitalize">
              {moment(item?.payment_schedule?.month).format("MMM / YYYY")}
            </span>
          </Col>
        );
      },
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: "ascend",
    },
    {
      title: "Fecha Limite de Pago",
      dataIndex: "month",
      key: "month",
      width: 6,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <span className="capitalize">
              {moment(item?.payment_schedule?.day_of_month_payment_limit).format("YYYY/MM/DD")}
            </span>
          </Col>
        );
      },
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: "ascend",
    },
    {
      title: "Valor extraordinario",
      key: "program_payment_schedule_price",
      width: 5,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <span className="capitalize">
              {formatNumberPrice(+item?.program_payment_schedule_price)}
            </span>
          </Col>
        );
      },
    },
     {
      title: "Valor pronto pago",
      key: "program_payment_schedule_prompt_price",
      width: 5,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <span className="capitalize">
              {formatNumberPrice(+item?.program_payment_schedule_prompt_price)}
            </span>
          </Col>
        );
      },
    },
    {
      title: "Valor pagado del estudiante",
      key: "month",
      width: 6,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <span className="capitalize">
              {formatNumberPrice(item?.amount_paid)}
            </span>
          </Col>
        );
      },
    },
    {
      title: "Balance de cobro",
      key: "month",
      width: 6,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <span className="capitalize">
              {formatNumberPrice(item?.balance)}
            </span>
          </Col>
        );
      },
    },
    {
      title: "Fecha pago estudante",
      key: "month",
      width: 6,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <span className="capitalize">
              {item?.payment_due_date && moment(item?.payment_due_date).format('YYYY/MM/DD ')}
              {!item?.payment_due_date && 'Pendiente por pago'}
            </span>
          </Col>
        );
      },
    },
    {
      title: "Estado",
      dataIndex:'payment_status',
      key: "payment_status",
      width: 6,
      fixed: 'right',
      render: (_, item) => (
        <Col
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <PaymentStatusBadge
            status={item.payment_status}
            label={
              item.payment_status === "partial_payment"
                ? "Acuerdo de pago"
                : undefined
            }
          />
        </Col>
      ),
      filters: [
        {
          text: "Pagado",
          value: "paid",
        },
        {
          text: "Pendiente por pago",
          value: "unpaid",
        },
        {
          text: "Acuerdo de pago",
          value: "partial_payment",
        },
        {
          text: "Verificación de pago",
          value: "pending_verification",
        },
      ],
    },
  ];

  return (
    <>
      <Table<CopyProgramSchedulePaymentStudentType>
        columns={columns}
        fetchQueryProps={{
          status: 'active'
        }}
        service={programPaymentScheduleStudentAcademy}
      />
    </>
  );
};
